export function isInactiveTenantResponse(error) {
  return (
    error?.response?.status === 403 &&
    typeof error?.response?.data?.message === "string" &&
    error.response.data.message.toLowerCase().includes("inactive")
  );
}
